import React from 'react';
import { X, Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const UpgradePopup = ({ isOpen, onClose, message }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleUpgrade = (plan) => {
        // Navigate to pricing or handle upgrade logic
        navigate('/pricing/all');
        onClose();
    };

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in duration-200">

                {/* Header */}
                <div className="p-6 text-center border-b border-gray-100">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Upgrade to Continue</h3>
                    {(message && message !== '') ? (
                        <div className="mt-2 flex items-start gap-2 px-3 py-2.5 bg-red-50 border border-red-200 rounded-lg text-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-500 shrink-0 mt-0.5"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
                            <p className="text-red-700 text-sm leading-relaxed">
                                {typeof message === 'object' && message !== null ? JSON.stringify(message) : message}
                            </p>
                        </div>
                    ) : (
                        <p className="text-gray-500 text-sm mt-1">You've reached the limits of your current plan.</p>
                    )}
                </div>

                {/* Content */}
                <div className="p-6 space-y-4">

                    {/* Student Plan */}
                    <div className="border border-gray-200 rounded-xl p-4 hover:border-blue-500 hover:shadow-md transition-all cursor-pointer group" onClick={() => handleUpgrade('student')}>
                        <div className="flex justify-between items-center mb-2">
                            <h4 className="font-bold text-gray-900">Student Plan</h4>
                            <span className="bg-blue-100 text-blue-700 text-xs font-bold px-2 py-1 rounded-full">Popular</span>
                        </div>
                        <div className="flex justify-between items-end">
                            <ul className="text-xs text-gray-600 space-y-1">
                                <li className="flex items-center gap-1"><Check size={12} className="text-green-500" /> 10k Data Points</li>
                                <li className="flex items-center gap-1"><Check size={12} className="text-green-500" /> Unlimited Generations</li>
                            </ul>
                            <div className="text-right">
                                <span className="text-xl font-bold text-gray-900">₹399</span>
                                <span className="text-xs text-gray-500">/month</span>
                            </div>
                        </div>
                    </div>

                    {/* Pro Plan */}
                    <div className="border border-gray-200 rounded-xl p-4 hover:border-purple-500 hover:shadow-md transition-all cursor-pointer group" onClick={() => handleUpgrade('pro')}>
                        <div className="flex justify-between items-center mb-2">
                            <h4 className="font-bold text-gray-900">Pro Plan</h4>
                            <span className="bg-purple-100 text-purple-700 text-xs font-bold px-2 py-1 rounded-full">Best Value</span>
                        </div>
                        <div className="flex justify-between items-end">
                            <ul className="text-xs text-gray-600 space-y-1">
                                <li className="flex items-center gap-1"><Check size={12} className="text-green-500" /> 200k Data Points</li>
                                <li className="flex items-center gap-1"><Check size={12} className="text-green-500" /> API Access</li>
                            </ul>
                            <div className="text-right">
                                <span className="text-xl font-bold text-gray-900">₹1,199</span>
                                <span className="text-xs text-gray-500">/month</span>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Footer */}
                <div className="p-4 border-t border-gray-100 bg-gray-50 flex gap-3 justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
                    >
                        Skip
                    </button>
                    <button
                        onClick={() => navigate('/pricing')}
                        className="px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 rounded-lg shadow-md hover:shadow-lg transition-all"
                    >
                        View All Plans
                    </button>
                </div>

            </div>
        </div>
    );
};

export default UpgradePopup;
